import { useMercuryStore } from "entities/mercury"
import { useVetisStore } from "entities/vetis";

export const useVetisContent = () => {
  const defaultBusinessEntitity = useMercuryStore(s => s.defaultBusinessEntitity);
  const setBusinessDrawerOpen = useVetisStore(s => s.setBusinessDrawerOpen);
  const setOpenUserAfterAddBusiness = useVetisStore(s => s.setOpenUserAfterAddBusiness);
  
  const vetisUser = useVetisStore(s => s.vetisUser);
  const removeUser = useVetisStore(s => s.removeUser);
  const removeBusiness = useVetisStore(s => s.removeBusiness);

  const onButtonClick = () => {
    setOpenUserAfterAddBusiness(true);
    setBusinessDrawerOpen(true);
  }

  const onLogoutButtonClick = () => {
    const externalId = vetisUser?.externalId;
    const businessExternalId = vetisUser?.business?.externalId;

    if (businessExternalId === externalId) {
      return removeBusiness()
    }

    return removeUser();
  }

  return {
    defaultBusinessEntitity,
    onButtonClick,
    onLogoutButtonClick
  }
}